/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/models/meevo.model.custom.ts"/>
///<reference path="../../../components/baseClasses/guid.ts"/>
///<reference path="../../../components/models/meevo.dtos.d.ts"/>
///<reference path="system-tags-models.ts"/>

module Meevo.Plugins.DocsAndForms {

    import BusinessInfoDataService = Meevo.Components.Common.BusinessInfoDataService;
    import ISelectItem = Meevo.Model.ISelectItem;
    import ReferredByEnum = Meevo.Model.ReferredByEnum;
    import EnumTypeEnum = Meevo.Model.EnumTypeEnum;
    import IBusinessInfoSettings = Meevo.Plugins.BusinessInfo.IBusinessInfoSettings;
    import DataServiceBase = Meevo.Components.BaseClasses.DataServiceBase;
    import BusinessInfo = Meevo.Model.BusinessInfo;
    import DataService = Meevo.Components.Common.DataService;

    const referredList: ISelectItem<string | number>[] = Object
        .keys(ReferredByEnum)
        .filter((key) => !Number(key))
        .map((key) => ({ label: key, value: ReferredByEnum[key] }));

    export class SystemTagsFactory {
        public static factory(): Function {
            const instance = (appSettings: Meevo.Components.Common.IAppSettings,
                postalCodeService: Meevo.Components.Common.IPostalCodeService,
                dataService: Meevo.Components.BaseClasses.IDataService,
                $q: ng.IQService,
                busInfoService: BusinessInfoDataService) => {
                return new SystemTagsFactory(appSettings, postalCodeService, dataService, $q, busInfoService);
            };

            instance.$inject = [
                'meevo.AppSettings',
                'meevo.components.common.PostalCodeService',
                'meevo.components.common.DataService',
                '$q',
                'meevo.components.common.BusinessInfoDataService',
            ];

            return instance;
        }

        DOCS_AND_FORMS_SYSTEM_TAGS: ISystemTagModel[] = [];
        DOCS_AND_FORMS_SYSTEM_TAGS_MEMBERSHIP: ISystemTagModel[] = [];
        DOCS_AND_FORMS_SYSTEM_TAGS_PAYMENTPLAN: ISystemTagModel[] = [];
        CLIENT_INTAKE_FORM_SYSTEM_TAGS: ISystemTagModel[] = [];
        excludeForMemberShip: string[] = [];
        excludeForPaymentPlan: string[] = [];

        states: { value: string; label: string; }[] = [];
        busInfo: IBusinessInfoSettings = {} as IBusinessInfoSettings;
        genderList: ISelectItem<string | number>[] = [];

        constructor(private appSettings: Meevo.Components.Common.IAppSettings,
            private postalCodeService: Meevo.Components.Common.IPostalCodeService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private $q: ng.IQService,
            private busInfoService: BusinessInfoDataService) {
            this.DOCS_AND_FORMS_SYSTEM_TAGS_MEMBERSHIP = [
                new SystemTagLabelModel('{Membership.MembershipNumber}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_NUMBER'),
                new SystemTagLabelModel('{Membership.DisplayName}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_DISPLAY_NAME'), 
                new SystemTagLabelModel('{Membership.MembershipLength}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_LENGTH'),
                new SystemTagLabelModel('{Membership.MembershipLengthType}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_LENGTHTYPE'),
                new SystemTagLabelModel('{Membership.BillingType}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_BILLING_TYPE'), 
                new SystemTagLabelModel('{Membership.MemberType}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_TYPE'),
                new SystemTagLabelModel('{Membership.AutoRenewal}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_AUTO_RENEWAL'),
                new SystemTagLabelModel('{Membership.EnrollmentFee}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_ENROLLMENT_FEE'),
                new SystemTagLabelModel('{Membership.RecurringFee}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_RECURRING_FEE'),
                new SystemTagLabelModel('{Membership.RenewalFee}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_RENEWAL_FEE'),
                new SystemTagLabelModel('{path=Membership.EnrollmentDate,format=d}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_ENROLLMENT_DATE'),
                new SystemTagLabelModel('{path=Membership.FirstPaymentDate,format=d}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_FIRST_PAYMENT_DATE'),
                new SystemTagLabelModel('{Membership.PrimaryMember}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_PRIMARY_MEMBER'),
                new SystemTagLabelModel('{Membership.PrimaryPaymentMethod}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_PRIMARY_METHOD_OF_PAYMENT'),
                new SystemTagLabelModel('{Membership.PrimaryPaymentMethodDetails}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_PRIMARY_METHOD_OF_PAYMENT_DETAILS'),
                new SystemTagLabelModel('{Membership.SecondaryPaymentMethod}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_SECONDARY_METHOD_OF_PAYMENT'),
                new SystemTagLabelModel('{Membership.SecondaryPaymentMethodDetails}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_SECONDARY_METHOD_OF_PAYMENT_DETAILS'),
                new SystemTagLabelModel('{Membership.PackagesIncluded}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_PACKAGES_INCLUDED'),
                new SystemTagLabelModel('{Membership.BenefitsServicesDiscount}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_BENEFITS_SERVICES_DISCOUNT'),
                new SystemTagLabelModel('{Membership.BenefitsProductsDiscount}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_BENEFITS_PRODUCTS_DISCOUNT'),
                new SystemTagLabelModel('{Membership.BenefitsPackagesDiscount}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_BENEFITS_PACKAGES_DISCOUNT'),
                new SystemTagLabelModel('{Membership.BenefitsServicesOverrides}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_BENEFITS_SERVICES_OVERRIDES'),
                new SystemTagLabelModel('{Membership.BenefitsProductsOverrides}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_BENEFITS_PRODUCTS_OVERRIDES'),
                new SystemTagLabelModel('{Membership.BenefitsPackagesOverrides}', 'LABEL_SYSTEM_TAG_MEMBERSHIP_BENEFITS_PACKAGES_OVERRIDES')]

            this.DOCS_AND_FORMS_SYSTEM_TAGS_PAYMENTPLAN = [
                new SystemTagLabelModel('{PaymentPlan.RemainingBalance}', 'LABEL_SYSTEM_TAG_PAYMENTPLAN_REMAINING_AMOUNT'),
                new SystemTagLabelModel('{PaymentPlan.NumberOfPaymentRemaining}', 'LABEL_SYSTEM_TAG_PAYMENTPLAN_TOTAL_NUMBER_OF_PAYMENT_REMAINING'),
                new SystemTagLabelModel('{path=PaymentPlan.PaymentDateOfTheMonth,format=d}', 'LABEL_SYSTEM_TAG_PAYMENTPLAN_PAYMENT_DATE_OF_THE_MONTH')]

            this.excludeForMemberShip =
                ['LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_CONFIRMATIONS',
                    'LABEL_SYSTEM_TAG_APPOINTMENT_SERVICE',
                    'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_BOOKED',
                    'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_EDITED',
                    'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_CANCELLED',
                'LABEL_SYSTEM_TAG_APPOINTMENT_SERVICE_DATE_TIME',
                'LABEL_SYSTEM_TAG_PAYMENTPLAN_REMAINING_AMOUNT',
                'LABEL_SYSTEM_TAG_PAYMENTPLAN_TOTAL_NUMBER_OF_PAYMENT_REMAINING',
                'LABEL_SYSTEM_TAG_PAYMENTPLAN_PAYMENT_DATE_OF_THE_MONTH'
                ]

            this.excludeForPaymentPlan =
                ['LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_CONFIRMATIONS',
                    'LABEL_SYSTEM_TAG_APPOINTMENT_SERVICE',
                    'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_BOOKED',
                    'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_EDITED',
                    'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_CANCELLED',
                    'LABEL_SYSTEM_TAG_APPOINTMENT_SERVICE_DATE_TIME'
                ]


        }
        getDocsAndFormsSystemTags(formFillTypeEnum: FormFillTypeEnum) {
            //Membership form type contains both
            if (formFillTypeEnum == FormFillTypeEnum.Membership) {
                return this.DOCS_AND_FORMS_SYSTEM_TAGS_MEMBERSHIP.slice().concat(
                    this.DOCS_AND_FORMS_SYSTEM_TAGS.filter(x => !this.excludeForMemberShip.some(y => y === x.label))
                )
            } if (formFillTypeEnum == FormFillTypeEnum.PaymentPlan)
            {
                return this.DOCS_AND_FORMS_SYSTEM_TAGS_PAYMENTPLAN.slice().concat(
                    this.DOCS_AND_FORMS_SYSTEM_TAGS.filter(x => !this.excludeForPaymentPlan.some(y => y === x.label))
                )
            }
            else {
                return this.DOCS_AND_FORMS_SYSTEM_TAGS;
            }
        }

        prepareDocsAndFormsSystemTags() {
            if (this.DOCS_AND_FORMS_SYSTEM_TAGS.length > 0) {
                return this.$q.resolve(this.DOCS_AND_FORMS_SYSTEM_TAGS);
            }

            return this._preloadSystemTagsData().then(([busInfo, states, genders]) => {
                const {
                    requireNewClientPhoneNumber,
                    requireNewClientEmail,
                    requireNewClientReferralType,
                    requireBirthdayWhenSavingClientProfile,
                    forceGenderSelection
                } = busInfo.clientsSettings;
                const businessLogoUrl = busInfo.imageUrl;

                return this.DOCS_AND_FORMS_SYSTEM_TAGS = [
                    //#regionGuardian
                    new SystemTagTextBoxModel('{Guardian.LastName}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_LAST_NAME'),
                    new SystemTagTextBoxModel('{Guardian.FirstName}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_FIRST_NAME'),
                    new SystemTagTextBoxModel('{Guardian.Address.Address1}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_ADDRESS_1'),
                    new SystemTagTextBoxModel('{Guardian.Address.City}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_CITY'),
                    new SystemTagSelectModel('{Guardian.Address.State}', '{Guardian.Address.State}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_STATE', states),
                    new SystemTagTextBoxModel('{Guardian.Address.ZipCode}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_ZIP'),
                    new SystemTagTextBoxModel('{Guardian.PrimaryPhone}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_PHONE'),
                    new SystemTagEmailModel('{Guardian.EmailAddress}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_EMAIL'),
                    //#endregionGuardian
                    //#regionClient
                    new SystemTagTextBoxModel('{Client.Prefix}', 'LABEL_SYSTEM_TAG_CLIENT_PREFIX'),
                    new SystemTagFirstLastNamesModel('{Client.FirstName}', 'LABEL_SYSTEM_TAG_CLIENT_FIRST_NAME', {
                        required: true,
                        selected: true,
                        requiredEditable: true,
                        readOnlyEditable: true,
                    }),
                    new SystemTagFirstLastNamesModel('{Client.LastName}', 'LABEL_SYSTEM_TAG_CLIENT_LAST_NAME', {
                        required: true,
                        selected: true,
                        requiredEditable: true,
                        readOnlyEditable: true,
                    }),
                    new SystemTagTextBoxModel('{Client.MiddleName}', 'LABEL_SYSTEM_TAG_CLIENT_MIDDLE_NAME'),
                    new SystemTagSelectModel('{Client.Gender}', '{path=Client.Gender,format=d}', 'LABEL_SYSTEM_TAG_CLIENT_GENDER', genders, {
                        required: forceGenderSelection,
                        requiredEditable: !forceGenderSelection,
                        selected: forceGenderSelection,
                        disable: forceGenderSelection
                    }),
                    new SystemTagTextBoxModel('{Client.Address.Address1}', 'LABEL_SYSTEM_TAG_CLIENT_ADDRESS_1'),
                    new SystemTagTextBoxModel('{Client.Address.Address2}', 'LABEL_SYSTEM_TAG_CLIENT_ADDRESS_2'),
                    new SystemTagTextBoxModel('{Client.Address.City}', 'LABEL_SYSTEM_TAG_CLIENT_CITY'),
                    new SystemTagSelectModel('{Client.Address.State}', '{Client.Address.State}', 'LABEL_SYSTEM_TAG_CLIENT_STATE', states),
                    new SystemTagTextBoxModel('{Client.Address.ZipCode}', 'LABEL_SYSTEM_TAG_CLIENT_ZIP_CODE'),
                    new SystemTagReferredModel('{Client.ReferredByEnum}', '{Client.ReferredByEnum}', 'LABEL_SYSTEM_TAG_CLIENT_REFERRED', referredList, {
                        required: requireNewClientReferralType,
                        selected: requireNewClientReferralType,
                        requiredEditable: !requireNewClientReferralType
                    }),
                    new SystemTagEmailModel('{Client.EmailAddress}', 'LABEL_SYSTEM_TAG_CLIENT_EMAIL_ADDRESS', {
                        required: requireNewClientEmail,
                        selected: requireNewClientEmail,
                        requiredEditable: !requireNewClientEmail
                    }),
                    new SystemTagCheckBoxModel('{Client.IsMarketingEmailEnabled}', 'LABEL_SYSTEM_TAG_CLIENT_MARKETING_SEND_EMAIL'),
                    new SystemTagCountryPhoneModel('{Client.PrimaryPhone}', 'LABEL_SYSTEM_TAG_CLIENT_MOBILE_PHONE', {
                        required: requireNewClientPhoneNumber,
                        selected: requireNewClientPhoneNumber,
                        requiredEditable: !requireNewClientPhoneNumber,
                        countryPhoneCodeKey: '{Client.PrimaryPhoneCountryCode}',
                        countryCodeKey: '{Client.PrimaryPhoneCountryISO2Code}'
                    }),
                    new SystemTagCheckBoxModel('{Client.IsMinor}', 'LABEL_SYSTEM_TAG_CLIENT_IS_MINOR'),
                    new SystemTagCheckBoxModel('{Client.IsEmailOptedIn}', 'LABEL_SYSTEM_TAG_CLIENT_NOTIFICATIONS_SEND_EMAIL'),
                    new SystemTagCheckBoxModel('{Client.UsePrimaryPhoneForSMS}', 'LABEL_SYSTEM_TAG_CLIENT_TEXT_NOTIFICATIONS_OPT_IN'),
                    new SystemTagCheckBoxModel('{Client.MarketingSendText}', 'LABEL_SYSTEM_TAG_CLIENT_MARKETING_SEND_TEXT'),
                    new SystemTagLabelModel('{Client.SmsOptInStateEnum}', 'LABEL_SYSTEM_TAG_OPT_IN_STATUS'),
                    new SystemTagCheckBoxModel('{Client.DoNotConfirm}', 'LABEL_SYSTEM_TAG_CLIENT_DO_NOT_CONFIRM'),
                    new SystemTagNotificationModel('{Client.AppointmentConfirmation}', 'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_CONFIRMATIONS', { communication: 1795 }, true),
                    new SystemTagNotificationModel('{Client.AppointmentReminderDaysBefore}', 'LABEL_SYSTEM_TAG_CLIENT_REMINDERS', { communication: 1833 }, true),
                    new SystemTagNotificationModel('{Client.AppointmentReminderOnAdd}', 'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_BOOKED', { communication: 1817 }),
                    new SystemTagNotificationModel('{Client.AppointmentReminderOnUpdate}', 'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_EDITED', { communication: 1832 }),
                    new SystemTagNotificationModel('{Client.AppointmentReminderOnCancel}', 'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_CANCELLED', { communication: 2036 }),
                    new SystemTagNotificationModel('{Client.FiveStarSurvey}', 'LABEL_SYSTEM_TAG_5_STAR_RATINGS_OPT_IN', { communication: 30423 }),
                    new SystemTagBirthDatModel('Client', 'LABEL_SYSTEM_TAG_CLIENT_BIRTHDAY', {
                        required: requireBirthdayWhenSavingClientProfile,
                        requiredEditable: !requireBirthdayWhenSavingClientProfile
                    }),
                    new SystemTagDateModel('{Client.AnniversaryDate}', 'LABEL_SYSTEM_TAG_CLIENT_ANNIVERSARY', '{path=Client.AnniversaryDate,format=d}'),
                    //#endregionClient
                    //#regionAppointment
                    new SystemTagLabelModel('{Appointment.FirstServiceName}', 'LABEL_SYSTEM_TAG_APPOINTMENT_SERVICE'),
                    new SystemTagLabelModel('{path=Appointment.AppointmentDateLong,format=d} {path=Appointment.AppointmentTime,format=d}', 'LABEL_SYSTEM_TAG_APPOINTMENT_SERVICE_DATE_TIME'),
                    //#endregionAppointment
                    new SystemTagViewImageModel('{BusinessInfo.ImageUrl}', 'LABEL_SYSTEM_TAG_BUSINESS_INFO_LOGO', {
                        width: 200,
                        height: 200
                    }, {
                        required: false,
                        requiredEditable: false,
                        readOnly: true,
                        readOnlyEditable: false,
                        selected: true,
                        disable: false,
                        imgUrl: businessLogoUrl,
                    }),
                    new SystemTagLabelModel('{BusinessInfo.Name}', 'LABEL_SYSTEM_TAG_BUSINESS__NAME'),
                    new SystemTagDateModel('{TodayDateTime}', 'LABEL_SYSTEM_TAG_TODAY_DATE', '{path=TodayDateTime,format=d}', {
                        required: false,
                        readOnly: true,
                        requiredEditable: false,
                        readOnlyEditable: false
                    }),
                ];
            });
        }

        prepareClientIntakeFormSystemTags() {
            if (this.CLIENT_INTAKE_FORM_SYSTEM_TAGS.length > 0) {
                return this.$q.resolve(this.CLIENT_INTAKE_FORM_SYSTEM_TAGS);
            }

            return this._preloadSystemTagsData().then(([busInfo, states, genders]) => {
                const {
                    requireNewClientPhoneNumber,
                    requireNewClientEmail,
                    requireNewClientReferralType,
                    requireBirthdayWhenSavingClientProfile,
                    forceGenderSelection
                } = busInfo.clientsSettings;
                const businessLogoUrl = busInfo.imageUrl;

                return this.CLIENT_INTAKE_FORM_SYSTEM_TAGS = [
                    //#regionGuardian
                    new SystemTagTextBoxModel('{Guardian.LastName}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_LAST_NAME'),
                    new SystemTagTextBoxModel('{Guardian.FirstName}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_FIRST_NAME'),
                    new SystemTagTextBoxModel('{Guardian.Address.Address1}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_ADDRESS_1'),
                    new SystemTagTextBoxModel('{Guardian.Address.City}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_CITY'),
                    new SystemTagSelectModel('{Guardian.Address.State}', '{Guardian.Address.State}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_STATE', states),
                    new SystemTagTextBoxModel('{Guardian.Address.ZipCode}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_ZIP'),
                    new SystemTagTextBoxModel('{Guardian.PrimaryPhone}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_PHONE'),
                    new SystemTagEmailModel('{Guardian.EmailAddress}', 'LABEL_SYSTEM_TAG_GUARDIAN_CLIENT_EMAIL'),
                    //#endregionGuardian
                    new SystemTagTextBoxModel('{Client.Prefix}', 'LABEL_SYSTEM_TAG_CLIENT_PREFIX'),
                    new SystemTagTextBoxModel('{Client.FirstName}', 'LABEL_SYSTEM_TAG_CLIENT_FIRST_NAME', {
                        required: true,
                        requiredEditable: false,
                        selected: true,
                        disable: true
                    }),
                    new SystemTagTextBoxModel('{Client.LastName}', 'LABEL_SYSTEM_TAG_CLIENT_LAST_NAME', {
                        required: true,
                        requiredEditable: false,
                        selected: true,
                        disable: true
                    }),
                    new SystemTagTextBoxModel('{Client.MiddleName}', 'LABEL_SYSTEM_TAG_CLIENT_MIDDLE_NAME'),
                    new SystemTagSelectModel('{Client.Gender}', '{path=Client.Gender,format=d}', 'LABEL_SYSTEM_TAG_CLIENT_GENDER', genders, {
                        required: forceGenderSelection,
                        requiredEditable: !forceGenderSelection,
                        selected: forceGenderSelection,
                        disable: forceGenderSelection
                    }),
                    new SystemTagTextBoxModel('{Client.Address.Address1}', 'LABEL_SYSTEM_TAG_CLIENT_ADDRESS_1'),
                    new SystemTagTextBoxModel('{Client.Address.Address2}', 'LABEL_SYSTEM_TAG_CLIENT_ADDRESS_2'),
                    new SystemTagTextBoxModel('{Client.Address.City}', 'LABEL_SYSTEM_TAG_CLIENT_CITY'),
                    new SystemTagSelectModel('{Client.Address.State}', '{Client.Address.State}', 'LABEL_SYSTEM_TAG_CLIENT_STATE', states),
                    new SystemTagTextBoxModel('{Client.Address.ZipCode}', 'LABEL_SYSTEM_TAG_CLIENT_ZIP_CODE'),
                    new SystemTagReferredModel('{Client.ReferredByEnum}', '{Client.ReferredByEnum}', 'LABEL_SYSTEM_TAG_CLIENT_REFERRED', referredList, {
                        required: requireNewClientReferralType,
                        requiredEditable: !requireNewClientReferralType,
                        selected: requireNewClientReferralType,
                        disable: requireNewClientReferralType
                    }),
                    new SystemTagEmailModel('{Client.EmailAddress}', 'LABEL_SYSTEM_TAG_CLIENT_EMAIL_ADDRESS', {
                        required: requireNewClientEmail,
                        requiredEditable: !requireNewClientEmail,
                        selected: requireNewClientEmail,
                        disable: requireNewClientEmail
                    }),
                    new SystemTagCheckBoxModel('{Client.IsMarketingEmailEnabled}', 'LABEL_SYSTEM_TAG_CLIENT_MARKETING_SEND_EMAIL'),
                    new SystemTagCountryPhoneModel('{Client.PrimaryPhone}', 'LABEL_SYSTEM_TAG_CLIENT_MOBILE_PHONE', {
                        required: requireNewClientPhoneNumber,
                        selected: requireNewClientPhoneNumber,
                        requiredEditable: !requireNewClientPhoneNumber,
                        countryPhoneCodeKey: '{Client.PrimaryPhoneCountryCode}',
                        countryCodeKey: '{Client.PrimaryPhoneCountryISO2Code}'
                    }),
                    new SystemTagCheckBoxModel('{Client.IsMinor}', 'LABEL_SYSTEM_TAG_CLIENT_IS_MINOR'),
                    new SystemTagCheckBoxModel('{Client.IsEmailOptedIn}', 'LABEL_SYSTEM_TAG_CLIENT_NOTIFICATIONS_SEND_EMAIL'),
                    new SystemTagCheckBoxModel('{Client.UsePrimaryPhoneForSMS}', 'LABEL_SYSTEM_TAG_CLIENT_TEXT_NOTIFICATIONS_OPT_IN'),
                    new SystemTagCheckBoxModel('{Client.MarketingSendText}', 'LABEL_SYSTEM_TAG_CLIENT_MARKETING_SEND_TEXT'),
                    new SystemTagLabelModel('{Client.SmsOptInStateEnum}', 'LABEL_SYSTEM_TAG_OPT_IN_STATUS'),
                    new SystemTagCheckBoxModel('{Client.DoNotConfirm}', 'LABEL_SYSTEM_TAG_CLIENT_DO_NOT_CONFIRM'),
                    new SystemTagNotificationModel('{Client.AppointmentConfirmation}', 'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_CONFIRMATIONS', { communication: 1795 }, true),
                    new SystemTagNotificationModel('{Client.AppointmentReminderDaysBefore}', 'LABEL_SYSTEM_TAG_CLIENT_REMINDERS', { communication: 1833 }, true),
                    new SystemTagNotificationModel('{Client.AppointmentReminderOnAdd}', 'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_BOOKED', { communication: 1817 }),
                    new SystemTagNotificationModel('{Client.AppointmentReminderOnUpdate}', 'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_EDITED', { communication: 1832 }),
                    new SystemTagNotificationModel('{Client.AppointmentReminderOnCancel}', 'LABEL_SYSTEM_TAG_CLIENT_APPOINTMENT_CANCELLED', { communication: 2036 }),
                    new SystemTagNotificationModel('{Client.FiveStarSurvey}', 'LABEL_SYSTEM_TAG_5_STAR_RATINGS_OPT_IN', { communication: 30423 }),
                    new SystemTagBirthDatModel('Client', 'LABEL_SYSTEM_TAG_CLIENT_BIRTHDAY', {
                        required: requireBirthdayWhenSavingClientProfile,
                        requiredEditable: !requireBirthdayWhenSavingClientProfile,
                        selected: requireBirthdayWhenSavingClientProfile,
                        disable: requireBirthdayWhenSavingClientProfile
                    }),
                    new SystemTagDateModel('{Client.AnniversaryDate}', 'LABEL_SYSTEM_TAG_CLIENT_ANNIVERSARY', '{path=Client.AnniversaryDate,format=d}'),
                    new SystemTagViewImageModel('{BusinessInfo.ImageUrl}', 'LABEL_SYSTEM_TAG_BUSINESS_INFO_LOGO', {
                        width: 200,
                        height: 200
                    }, {
                        required: false,
                        requiredEditable: false,
                        readOnly: true,
                        readOnlyEditable: false,
                        selected: true,
                        disable: false,
                        imgUrl: businessLogoUrl,
                    }),
                    new SystemTagLabelModel('{BusinessInfo.Name}', 'LABEL_SYSTEM_TAG_BUSINESS__NAME'),
                    new SystemTagDateModel('{TodayDateTime}', 'LABEL_SYSTEM_TAG_TODAY_DATE', '{path=TodayDateTime,format=d}', {
                        required: false,
                        readOnly: true,
                        requiredEditable: false,
                        readOnlyEditable: false
                    }),
                ];
            });
        }

        formHasSystemTags(model: DocsAndFormsModel): boolean {
            if (!model.templateHTML) {
                return false;
            }

            const systemTags = model.tabTypeEnum === Meevo.Model.FormTypeEnum.Form
                ? this.getDocsAndFormsSystemTags(model.formFillTypeEnum) : this.CLIENT_INTAKE_FORM_SYSTEM_TAGS
                ;

            return systemTags.reduce((res: number, current: ISystemTag) => {
                return res + (model.templateHTML.indexOf(current.key) + 1);
            }, 0) > 0;
        }

        hasInvalidSystemTags(model: DocsAndFormsModel): boolean {            
            if (!model.templateHTML) {
                return false;
            }   
            
            var invalidSystemTags ;               
            if (model.formFillTypeEnum == FormFillTypeEnum.Membership) {
                invalidSystemTags = this.DOCS_AND_FORMS_SYSTEM_TAGS.filter(x => this.excludeForMemberShip.some(y => y === x.label))
                    .concat(this.DOCS_AND_FORMS_SYSTEM_TAGS_PAYMENTPLAN);
            } else if (model.formFillTypeEnum == FormFillTypeEnum.PaymentPlan) {
                invalidSystemTags = this.DOCS_AND_FORMS_SYSTEM_TAGS.filter(x => this.excludeForPaymentPlan.some(y => y === x.label))
                    .concat(this.DOCS_AND_FORMS_SYSTEM_TAGS_MEMBERSHIP);
            } else {
                invalidSystemTags = this.DOCS_AND_FORMS_SYSTEM_TAGS_MEMBERSHIP;
            }            
         
            return invalidSystemTags.some((current: ISystemTag) => model.templateHTML.indexOf(current.key) >= 0);
        }

        private _preloadSystemTagsData() {
            return this.$q.all([
                this.busInfoService.getBusinessInfoPreferences().then(busInfo => this.busInfo = busInfo),
                this.postalCodeService.getStates({ country: this.appSettings.APP_ISOCOUNTRYCODE }).then((result) => this.states = (result.data || [])
                    .map((row) => ({ label: row.state, value: row.state }))
                ),
                this.dataService.getEnumList(EnumTypeEnum.GenderEnum).then(genders => this.genderList = genders.map(row => ({
                    label: row.displayName,
                    value: row.id
                })))
            ]);
        }
    }

    angular.module('meevo.plugins.docsAndForms')
        .service('meevo.plugins.docsAndForms.SystemTagsFactory', SystemTagsFactory.factory());
}
